<aside class="sidebar d-none d-md-block" [class.collapsed]="isCollapsed">
  <div class="header d-flex justify-content-center" [class.logo-space]="!isCollapsed">
    <div class="header-content d-flex justify-content-center" [class.collapsed]="isCollapsed">
      <div class="logo d-flex justify-content-center">
        <a [routerLink]="homeRoute" class="logo-link d-flex justify-content-center">
          <img
            [src]="'assets/images/Admain-fest-logo.svg'"
            alt="Lead Management System Logo"
            class="logo-image"
            [width]="isCollapsed ? 40 : 80"
            [height]="isCollapsed ? 40 : 80"
          />
          <!-- <span class="logo-text" [class.collapsed]="isCollapsed">LMS</span> -->
        </a>
      </div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <!-- Dashboard -->
    <!-- @if (!has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/dashboard" routerLinkActive="active">
        <i class="bi bi-speedometer2"></i>
        <span class="label">Dashboard</span>
      </a>
    } -->

    <!-- @if (has(PERMISSIONS.DASHBOARD.SUPER_ADMIN)) {
      <a routerLink="/super-admin-dashboard" routerLinkActive="active">
        <i class="bi bi-speedometer2"></i>
        <span class="label">Super Admin Dashboard</span>
      </a>
    } -->
    @if (has(PERMISSIONS.DASHBOARD.VIEW)) {
      <a routerLink="/dashboard-component" routerLinkActive="active">
        <i class="bi bi-speedometer2"></i>
        <span class="label">Dashboard</span>
      </a>
    }

    <!-- Users -->
    @if (has(PERMISSIONS.USER.VIEW)) {
      <a routerLink="/users" routerLinkActive="active">
        <i class="bi bi-people"></i>
        <span class="label">Users</span>
      </a>
    }
    @if (has(PERMISSIONS.LEAD.VIEW)) {
      <a routerLink="/lead" routerLinkActive="active">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">Leads</span>
      </a>
    }

    @if (has(PERMISSIONS.DUPLICATE_LEAD.VIEW)) {
      <a routerLink="/duplicate-leads" routerLinkActive="active">
        <i class="bi bi-layers-half"></i>
        <span class="label">Duplicate Leads</span>
      </a>
    }
    @if (has(PERMISSIONS.LEAD_ASSIGNMENT_MODULE.VIEW)) {
      <a routerLink="/pending-lead-queue" routerLinkActive="active">
        <i class="bi bi-hourglass-split"></i>
        <span class="label">Pending Lead Queue</span>
      </a>
    }
    @if (has(PERMISSIONS.AGENT_LEAD.VIEW)) {
      <a routerLink="/my-leads" routerLinkActive="active">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">My Leads</span>
      </a>
    }
    @if (has(PERMISSIONS.AGENT_PERFORMANCE_REPORT.VIEW)) {
      <a routerLink="/agent-performance" routerLinkActive="active">
        <i class="bi bi-bar-chart-line-fill"></i>
        <span class="label">Agent Performance</span>
      </a>
    }
    @if (has(PERMISSIONS.CALL_DISPOSITION_REPORT.VIEW)) {
      <a routerLink="/call-disposition-report" routerLinkActive="active">
        <i class="bi bi-clipboard-data-fill"></i>
        <span class="label">Call Disposition Report</span>
      </a>
    }
    @if (has(PERMISSIONS.CONVERSION_REPORT.VIEW)) {
      <a routerLink="/conversion-report" routerLinkActive="active">
        <i class="bi bi-clipboard-data-fill"></i>
        <span class="label">Conversion Report</span>
      </a>
    }
    @if (has(PERMISSIONS.DAILY_CALL_REPORT.VIEW)) {
      <a routerLink="/daily-call-report" routerLinkActive="active">
        <i class="bi bi-telephone-fill"></i>
        <span class="label">Daily Call Report</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_CONFIG.VIEW)) {
      <a routerLink="/integration-setting-config" routerLinkActive="active">
        <i class="bi bi-clipboard-data-fill"></i>
        <span class="label">Integration Setting Config</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_SYNC_LOG.VIEW)) {
      <a routerLink="/integration-sync-log" routerLinkActive="active">
        <i class="bi bi-clipboard-data-fill"></i>
        <span class="label">Integration Sync Log</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_SYNC_ALERT.VIEW)) {
      <a routerLink="/integration-sync-alert" routerLinkActive="active">
        <i class="bi bi-person-lines-fill"></i>
        <span class="label">Integration Sync Alert</span>
      </a>
    }

    @if (canAccessCallbackQueue()) {
      <a routerLink="/callback-queue" routerLinkActive="active">
        <i class="bi bi-telephone-forward"></i>
        <span class="label">Callback Queue</span>
      </a>
    }

    @if (has(PERMISSIONS.FOLLOW_UP_PENDING_REPORT.VIEW)) {
      <a [routerLink]="reportRoute" routerLinkActive="active">
        <i class="bi bi-clock-history"></i>
        <span class="label">Follow-Up Pending Report</span>
      </a>
    }

    <!-- @if (has(PERMISSIONS.ADMIN.ACCESS)) {
      <a routerLink="/lead-upload" routerLinkActive="active">
        <i class="bi bi-file-earmark-arrow-up"></i>
        <span class="label">Lead Upload</span>
      </a>
    } -->

    <!-- Masters Group -->
    @if (canAccessMasters()) {
      <div class="menu-group me-2">
        <button
          class="dropdown-toggle"
          [class.open]="isMasterDataOpen"
          [class.active]="isMastersActive"
          (click)="toggleMasterData()"
        >
          <i class="bi bi-database"></i>
          <span class="label">Masters</span>
        </button>

        <div class="dropdown" [class.open]="isMasterDataOpen">
          @if (has(PERMISSIONS.LOCATION.COUNTRY_VIEW)) {
            <a routerLink="/countries" routerLinkActive="active">
              <i class="bi bi-flag"></i>
              <span class="label">Countries</span>
            </a>
          }

          @if (has(PERMISSIONS.LOCATION.STATE_VIEW)) {
            <a routerLink="/states" routerLinkActive="active">
              <i class="bi bi-map"></i>
              <span class="label">States</span>
            </a>
          }

          @if (has(PERMISSIONS.LOCATION.CITY_VIEW)) {
            <a routerLink="/cities" routerLinkActive="active">
              <i class="bi bi-building"></i>
              <span class="label">Cities</span>
            </a>
          }

          @if (has(PERMISSIONS.ROLE.VIEW)) {
            <a routerLink="/roles" routerLinkActive="active">
              <i class="bi bi-person-badge"></i>
              <span class="label">Roles</span>
            </a>
          }

          @if (has(PERMISSIONS.LEAD_SOURCE.VIEW)) {
            <a routerLink="/lead-sources" routerLinkActive="active">
              <i class="bi bi-megaphone"></i>
              <span class="label">Lead Sources</span>
            </a>
          }

          @if (has(PERMISSIONS.PROJECT.VIEW)) {
            <a routerLink="/project-master" routerLinkActive="active">
              <i class="bi bi-kanban"></i>
              <span class="label">Project Master</span>
            </a>
          }

          @if (has(PERMISSIONS.PROPERTY_CONFIGURATION.VIEW)) {
            <a routerLink="/property-configurations" routerLinkActive="active">
              <i class="bi bi-house-gear"></i>
              <span class="label">Property Configurations</span>
            </a>
          }
          @if (has(PERMISSIONS.DISPOSITION_CATEGORY.VIEW)) {
            <a routerLink="/disposition-categories" routerLinkActive="active">
              <i class="bi bi-house-gear"></i>
              <span class="label">Disposition categories </span>
            </a>
          }
          @if (has(PERMISSIONS.AREA_MASTER.VIEW)) {
            <a routerLink="/area-master" routerLinkActive="active">
              <i class="bi bi-rulers"></i>
              <span class="label">Area master </span>
            </a>
          }
          @if (has(PERMISSIONS.FLOOR_DETAIL.VIEW)) {
            <a routerLink="/floor-details" routerLinkActive="active">
              <i class="bi bi-buildings"></i>
              <span class="label">Floor Details </span>
            </a>
          }
          @if (has(PERMISSIONS.FURNISHING_STATUS.VIEW)) {
            <a routerLink="/furnishing-status" routerLinkActive="active">
              <i class="bi bi-lamp"></i>
              <span class="label"> Furnishing Status </span>
            </a>
          }
          @if (has(PERMISSIONS.PROPERTY_PURPOSE.VIEW)) {
            <a routerLink="/property-purpose" routerLinkActive="active">
              <i class="bi bi-buildings"></i>
              <span class="label">Property Purpose </span>
            </a>
          }
          @if (has(PERMISSIONS.POSSESSION.VIEW)) {
            <a routerLink="/possession" routerLinkActive="active">
              <i class="bi bi-key"></i>
              <span class="label">Possession </span>
            </a>
          }
        </div>
      </div>
    }
    @if (has(PERMISSIONS.DISTRIBUTION_SETTINGS.VIEW)) {
      <a routerLink="/settings" routerLinkActive="active">
        <i class="bi bi-gear"></i>
        <span class="label">Settings</span>
      </a>
    }
    @if (has(PERMISSIONS.DEVELOPER_SETTINGS.MANAGE)) {
      <a routerLink="/developer-settings" routerLinkActive="active">
        <i class="bi bi-code-slash"></i>
        <span class="label">Developer Settings</span>
      </a>
    }

    @if (canAccessRecordings()) {
      <a routerLink="/recording" routerLinkActive="active">
        <i class="bi bi-mic"></i>
        <span class="label">Recordings</span>
      </a>
    }
    <!-- <a routerLink="/customer-call-logs" routerLinkActive="active">
      <i class="bi bi-journal-text"></i>
      <span class="label">Customer Call Logs</span>
    </a> -->
  </nav>
</aside>
<!-- Mobile Side bar -->
<aside class="mobile-sidebar" [class.open]="isMobileOpen">
  <!-- Header -->
  <div class="mobile-header">
    <h5>Menu</h5>
    <button class="mobile-close-btn" (click)="closeMobile.emit()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Navigation -->
  <nav class="mobile-nav">
    @if (has(PERMISSIONS.DASHBOARD.VIEW)) {
      <a routerLink="/dashboard-component" routerLinkActive="active" class="menu-item">
        <i class="bi bi-speedometer2"></i>
        <span>Dashboard</span>
      </a>
    }

    @if (has(PERMISSIONS.USER.VIEW)) {
      <a routerLink="/users" routerLinkActive="active" class="menu-item">
        <i class="bi bi-people"></i>
        <span>Users</span>
      </a>
    }
    @if (has(PERMISSIONS.LEAD.VIEW)) {
      <a routerLink="/lead" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-lines-fill"></i>
        <span>Leads</span>
      </a>
    }

    @if (has(PERMISSIONS.DUPLICATE_LEAD.VIEW)) {
      <a routerLink="/duplicate-leads" routerLinkActive="active" class="menu-item">
        <i class="bi bi-layers-half"></i>
        <span>Duplicate Leads</span>
      </a>
    }
    @if (has(PERMISSIONS.LEAD_ASSIGNMENT_MODULE.VIEW)) {
      <a routerLink="/pending-lead-queue" routerLinkActive="active" class="menu-item">
        <i class="bi bi-hourglass-split"></i>
        <span>Pending Lead Queue</span>
      </a>
    }
    @if (has(PERMISSIONS.AGENT_LEAD.VIEW)) {
      <a routerLink="/my-leads" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-lines-fill"></i>
        <span>My Leads</span>
      </a>
    }

    @if (canAccessCallbackQueue()) {
      <a routerLink="/callback-queue" routerLinkActive="active" class="menu-item">
        <i class="bi bi-telephone-forward"></i>
        <span>Callback Queue</span>
      </a>
    }

    @if (has(PERMISSIONS.AGENT_PERFORMANCE_REPORT.VIEW)) {
      <a routerLink="/agent-performance" routerLinkActive="active" class="menu-item">
        <i class="bi bi-bar-chart-line-fill"></i>
        <span>Agent Performance</span>
      </a>
    }
    @if (has(PERMISSIONS.CALL_DISPOSITION_REPORT.VIEW)) {
      <a routerLink="/call-disposition-report" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clipboard-data-fill"></i>
        <span>Call Disposition Report</span>
      </a>
    }
    @if (has(PERMISSIONS.CONVERSION_REPORT.VIEW)) {
      <a routerLink="/conversion-report" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clipboard-data-fill"></i>
        <span>Conversion Report</span>
      </a>
    }
    @if (has(PERMISSIONS.DAILY_CALL_REPORT.VIEW)) {
      <a routerLink="/daily-call-report" routerLinkActive="active" class="menu-item">
        <i class="bi bi-telephone-fill"></i>
        <span>Daily Call Report</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_CONFIG.VIEW)) {
      <a routerLink="/integration-setting-config" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clipboard-data-fill"></i>
        <span>Integration Setting Config</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_SYNC_LOG.VIEW)) {
      <a routerLink="/integration-sync-log" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clipboard-data-fill"></i>
        <span>Integration Sync Log</span>
      </a>
    }
    @if (has(PERMISSIONS.INTEGRATION_SYNC_ALERT.VIEW)) {
      <a routerLink="/integration-sync-alert" routerLinkActive="active" class="menu-item">
        <i class="bi bi-person-lines-fill"></i>
        <span>Integration Sync Alert</span>
      </a>
    }

    @if (has(PERMISSIONS.FOLLOW_UP_PENDING_REPORT.VIEW)) {
      <a [routerLink]="reportRoute" routerLinkActive="active" class="menu-item">
        <i class="bi bi-clock-history"></i>
        <span>Follow-Up Pending Report</span>
      </a>
    }

    <!-- @if (has(PERMISSIONS.ADMIN.ACCESS)) {
      <a routerLink="/lead-upload" routerLinkActive="active" class="menu-item">
        <i class="bi bi-file-earmark-arrow-up"></i>
        <span>Lead Upload</span>
      </a>
    } -->

    <!-- Masters Section -->
    @if (canAccessMasters()) {
      <div class="master-section">
        <button
          class="dropdown-toggle"
          [class.open]="isMasterDataOpen"
          [class.active]="isMastersActive"
          (click)="toggleMasterData()"
        >
          <i class="bi bi-database"></i>
          <span>Masters</span>
        </button>

        <div class="dropdown" [class.open]="isMasterDataOpen">
          @if (has(PERMISSIONS.LOCATION.COUNTRY_VIEW)) {
            <a routerLink="/countries" routerLinkActive="active" class="submenu-item">
              Countries
            </a>
          }

          @if (has(PERMISSIONS.LOCATION.STATE_VIEW)) {
            <a routerLink="/states" routerLinkActive="active" class="submenu-item"> States </a>
          }

          @if (has(PERMISSIONS.LOCATION.CITY_VIEW)) {
            <a routerLink="/cities" routerLinkActive="active" class="submenu-item"> Cities </a>
          }

          @if (has(PERMISSIONS.ROLE.VIEW)) {
            <a routerLink="/roles" routerLinkActive="active" class="submenu-item"> Roles </a>
          }

          @if (has(PERMISSIONS.LEAD_SOURCE.VIEW)) {
            <a routerLink="/lead-sources" routerLinkActive="active" class="submenu-item">
              Lead Sources
            </a>
          }

          @if (has(PERMISSIONS.PROJECT.VIEW)) {
            <a routerLink="/project-master" routerLinkActive="active" class="submenu-item">
              Project Master
            </a>
          }

          @if (has(PERMISSIONS.PROPERTY_CONFIGURATION.VIEW)) {
            <a routerLink="/property-configurations" routerLinkActive="active" class="submenu-item">
              Property Configurations
            </a>
          }
          @if (has(PERMISSIONS.DISPOSITION_CATEGORY.VIEW)) {
            <a routerLink="/disposition-categories" routerLinkActive="active" class="submenu-item">
              Disposition categories
            </a>
          }
          @if (has(PERMISSIONS.AREA_MASTER.VIEW)) {
            <a routerLink="/area-master" routerLinkActive="active" class="submenu-item">
              Area master
            </a>
          }
          @if (has(PERMISSIONS.FLOOR_DETAIL.VIEW)) {
            <a routerLink="/floor-details" routerLinkActive="active" class="submenu-item">
              Floor Details
            </a>
          }
          @if (has(PERMISSIONS.FURNISHING_STATUS.VIEW)) {
            <a routerLink="/furnishing-status" routerLinkActive="active" class="submenu-item">
              Furnishing Status
            </a>
          }
          @if (has(PERMISSIONS.PROPERTY_PURPOSE.VIEW)) {
            <a routerLink="/property-purpose" routerLinkActive="active" class="submenu-item">
              Property Purpose
            </a>
          }
          @if (has(PERMISSIONS.POSSESSION.VIEW)) {
            <a routerLink="/possession" routerLinkActive="active" class="submenu-item">
              Possession
            </a>
          }
        </div>
      </div>
    }
    @if (has(PERMISSIONS.DISTRIBUTION_SETTINGS.VIEW)) {
      <a routerLink="/settings" routerLinkActive="active" class="menu-item">
        <i class="bi bi-gear"></i>
        <span>Settings</span>
      </a>
    }
    @if (has(PERMISSIONS.DEVELOPER_SETTINGS.MANAGE)) {
      <a routerLink="/developer-settings" routerLinkActive="active" class="menu-item">
        <i class="bi bi-code-slash"></i>
        <span>Developer Settings</span>
      </a>
    }
    @if (canAccessRecordings()) {
      <a routerLink="/recording" routerLinkActive="active" class="menu-item">
        <i class="bi bi-mic"></i>
        <span>Recordings</span>
      </a>
    }
    <!-- <a routerLink="/customer-call-logs" routerLinkActive="active" class="menu-item">
      <i class="bi bi-journal-text"></i>
      <span class="label">Customer Call Logs</span>
    </a> -->
  </nav>
</aside>
